// 2028 Writing Framework fluency metrics returned with every assessment.

export interface FluencyScore {
  syntactic_maturity: number;
  textual_cohesion: number;
  lexical_precision: number;
  summary: string;
}

export const FLUENCY_METRICS: {
  key: keyof Omit<FluencyScore, 'summary'>;
  label: string;
  desc: string;
}[] = [
  { key: 'syntactic_maturity', label: 'Syntactic Maturity', desc: 'Rhythmic pace and intentional variation in sentence length and structure.' },
  { key: 'textual_cohesion',   label: 'Textual Cohesion',   desc: 'Thread-linking across paragraphs via pronouns, adverbials, and conjunctions.' },
  { key: 'lexical_precision',  label: 'Lexical Precision',  desc: 'Genre-fitness of vocabulary choices to serve purpose and audience.' },
];
